import React, { useEffect, useState } from "react";  

export default function Footer() {
  const [showTopBtn, setShowTopBtn] = useState(false); 

  useEffect(() => {
    const handleScroll = () => setShowTopBtn(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

 
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="footer_bx">
      <div className="text-center footer_b">
        Copyright © {new Date().getFullYear()} Maa Pateswari University, Balrampur. All rights reserved.
      </div>

      {showTopBtn && (
        <button className="back-to-top" onClick={scrollToTop}>
          <i className="bi bi-arrow-up-short"></i>
        </button>
      )}
    </div>
  );
}
